import React from 'react';

const NewAccountTermsOfService = () => (
  <p className="terms-of-service-text">
    By continuing, you confirm that you have read and consent to our&nbsp;
    <a href="/terms.php" target="_blank" rel="noopener noreferrer">Terms of Use</a>
    &nbsp;and&nbsp;
    <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
    .
  </p>
);

export default NewAccountTermsOfService;



// WEBPACK FOOTER //
// ./src-react/NewAccountTermsOfService/index.jsx